import { render, staticRenderFns } from "./gch.vue?vue&type=template&id=5a3751c5&scoped=true"
var script = {}
import style0 from "./gch.vue?vue&type=style&index=0&id=5a3751c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3751c5",
  null
  
)

export default component.exports